module.exports = __webpack_public_path__ + "img/product-2-4-INT.4d6b2351.png";